__turbopack_context__.v({
  "className": "IBOVFG_className",
  "variable": "IBOVFG_variable",
});
